import en from "./en";

/**
 * Portuguese (Brazil). Same as English for Pokémon names; override here only when pt-BR differs.
 */
const ptBR: Record<string, string> = {
  ...en,
  // @begin move-names-i18n
  "move.acid-spray": "Spray Ácido",
  "move.acrobatics": "Acrobacia",
  "move.aerial-ace": "Golpe Aéreo",
  "move.agility": "Agilidade",
  "move.air-slash": "Talho Aéreo",
  "move.amnesia": "Amnésia",
  "move.anchor-shot": "Tiro Âncora",
  "move.ancient-power": "Poder Ancestral",
  "move.aqua-jet": "Aqua-jato",
  "move.aqua-ring": "Aqua-ring",
  "move.aqua-tail": "Rabo de Água",
  "move.armor-cannon": "Canhão Blindado",
  "move.assurance": "Garantia",
  "move.astonish": "Abalo",
  "move.aurora-veil": "Véu Aurora",
  "move.avalanche": "Avalanche",
  "move.baby-doll-eyes": "Olhos Encantadores",
  "move.barrier": "Barreira",
  "move.beat-up": "Surra",
  "move.belch": "Arroto",
  "move.bite": "Mordida",
  "move.bitter-blade": "Lâmina Amarga",
  "move.blaze": "Brasa",
  "move.blaze-kick": "Chute Labareda",
  "move.blizzard": "Nevasca",
  "move.block": "Bloqueio",
  "move.bone-rush": "Investida Óssea",
  "move.bounce": "Salto",
  "move.branch-poke": "Toque de Galho",
  "move.brave-bird": "Pássaro Bravio",
  "move.brutal-swing": "Giro Perverso",
  "move.bubble": "Bolha",
  "move.bubble-beam": "Raio Bolha",
  "move.bulk-up": "Corpulência",
  "move.bulldoze": "Tremor",
  "move.bullet-punch": "Soco Projétil",
  "move.bullet-seed": "Rajada de Sementes",
  "move.calm-mind": "Calma Mental",
  "move.charge-beam": "Raio Carregado",
  "move.charm": "Encanto",
  "move.close-combat": "Combate Corpo a Corpo",
  "move.coaching": "Treinamento",
  "move.confuse-ray": "Raio Confuso",
  "move.confusion": "Confusão",
  "move.cotton-guard": "Guarda de Algodão",
  "move.cotton-spore": "Esporo de Algodão",
  "move.covet": "Desejo",
  "move.cross-chop": "Talho Cruzado",
  "move.curse": "Maldição",
  "move.cut": "Corte",
  "move.dark-pulse": "Pulso Sombrio",
  "move.dark-void": "Buraco Negro",
  "move.dazzling-gleam": "Brilho Mágico",
  "move.decorate": "Decorar",
  "move.defense-curl": "Enrolar",
  "move.detect": "Detetar",
  "move.dig": "Cavar",
  "move.disable": "Desabilitar",
  "move.disarming-voice": "Voz Desarmante",
  "move.discharge": "Descarga",
  "move.dive": "Mergulho",
  "move.double-hit": "Golpe Duplo",
  "move.double-slap": "Tapa Duplo",
  "move.double-team": "Duplicidade",
  "move.draco-meteor": "Meteoro do Dragão",
  "move.dragon-breath": "Hálito de Dragão",
  "move.dragon-cheer": "Brado Dracônico",
  "move.dragon-claw": "Garra de Dragão",
  "move.dragon-dance": "Dança do Dragão",
  "move.dragon-pulse": "Pulso do Dragão",
  "move.dragon-rush": "Investida de Dragão",
  "move.dragon-tail": "Cauda de Dragão",
  "move.draining-kiss": "Beijo Drenante",
  "move.dream-eater": "Devorador de Sonhos",
  "move.drill-peck": "Bico Broca",
  "move.dual-wingbeat": "Asas Duplas",
  "move.dynamic-punch": "Soco Dinâmico",
  "move.earthquake": "Terremoto",
  "move.egg-bomb": "Bomba de Ovo",
  "move.electro-ball": "Bola Elétrica",
  "move.electro-drift": "Deriva Elétrica",
  "move.electroweb": "Teia Elétrica",
  "move.ember": "Brasas",
  "move.eruption": "Erupção",
  "move.explosive-heat-haze": "Neblina de Calor Explosiva",
  "move.extreme-speed": "Extrema Velocidade",
  "move.fairy-wind": "Vento de Fada",
  "move.fake-out": "Surpresa",
  "move.fake-tears": "Lágrimas Falsas",
  "move.feather-dance": "Dança de Penas",
  "move.feint": "Finta",
  "move.feint-attack": "Ataque Falso",
  "move.fell-stinger": "Ferrão Mortal",
  "move.fire-blast": "Rajada de Fogo",
  "move.fire-punch": "Soco de Fogo",
  "move.fire-spin": "Chama Furacão",
  "move.flail": "Agonizar",
  "move.flame-burst": "Rajas de Fogo",
  "move.flame-charge": "Nitrocarregamento",
  "move.flame-wheel": "Roda de Fogo",
  "move.flamethrower": "Lança-chamas",
  "move.flare-blitz": "Labareda",
  "move.flash-cannon": "Canhão de Luz",
  "move.flip-turn": "Viravolta",
  "move.floral-healing": "Cura Floral",
  "move.flower-trick": "Truque Floral",
  "move.fly": "Voo",
  "move.focus-blast": "Explosão Focada",
  "move.follow-me": "Chamariz",
  "move.foul-play": "Jogo Sujo",
  "move.freeze-dry": "Congelamento Seco",
  "move.fury-cutter": "Cortador de Fúria",
  "move.fury-swipes": "Golpes de Fúria",
  "move.future-sight": "Visão do Futuro",
  "move.giga-drain": "Gigadreno",
  "move.gigaton-hammer": "Marreta Gigaton",
  "move.grass-knot": "Nó de Grama",
  "move.grassy-glide": "Deslize Gramado",
  "move.gravity": "Gravidade",
  "move.growl": "Rosnar",
  "move.gyro-ball": "Girobola",
  "move.headbutt": "Cabeçada",
  "move.heal-pulse": "Pulso Cura",
  "move.heat-wave": "Onda de Calor",
  "move.heavy-slam": "Corpo Pesado",
  "move.helping-hand": "Mãozinha",
  "move.hex": "Malefício",
  "move.high-horsepower": "Força Equina",
  "move.hone-claws": "Afia Garras",
  "move.horn-leech": "Chifre de Suga",
  "move.hurricane": "Furacão",
  "move.hydro-cannon": "Hidrocanhão",
  "move.hydro-pump": "Jato d'Água",
  "move.hyper-beam": "Hiper Raio",
  "move.hyper-voice": "Hiper Voz",
  "move.hyperspace-hole": "Buraco Dimensional",
  "move.hypnosis": "Hipnose",
  "move.ice-beam": "Raio de Gelo",
  "move.ice-fang": "Presas de Gelo",
  "move.ice-hammer": "Martelo de Gelo",
  "move.ice-shard": "Estilha de Gelo",
  "move.icicle-crash": "Queda de Estalos",
  "move.icicle-spear": "Lança de Gelo",
  "move.icy-wind": "Vento Congelante",
  "move.imprison": "Aprisionar",
  "move.incinerate": "Incinerar",
  "move.iron-defense": "Defesa de Ferro",
  "move.iron-head": "Cabeça de Ferro",
  "move.jump-kick": "Chute em Salto",
  "move.karate-chop": "Golpe de Karatê",
  "move.knock-off": "Derrubar",
  "move.laser-focus": "Foco Laser",
  "move.lava-plume": "Pluma de Lava",
  "move.leaf-blade": "Folha Navalha",
  "move.leaf-storm": "Tempestade de Folhas",
  "move.leaf-tornado": "Tornado de Folhas",
  "move.leafage": "Folhagem",
  "move.leech-life": "Sanguessuga",
  "move.lick": "Lambida",
  "move.light-screen": "Tela de Luz",
  "move.liquidation": "Liquidação",
  "move.low-sweep": "Baixa Voadora",
  "move.lunge": "Arremetida",
  "move.luster-purge": "Purificação Lustrosa",
  "move.mach-punch": "Soco Mach",
  "move.magical-leaf": "Folha Mágica",
  "move.magnet-rise": "Eletromagnetismo",
  "move.mean-look": "Olhar Malvado",
  "move.mega-punch": "Megasoco",
  "move.megahorn": "Megachifre",
  "move.metal-claw": "Garra de Metal",
  "move.meteor-mash": "Meteoro Esmagador",
  "move.mist-ball": "Bola de Neblina",
  "move.moonblast": "Explosão Lunar",
  "move.moonlight": "Luar",
  "move.muddy-water": "Água Lodosa",
  "move.mystical-fire": "Fogo Místico",
  "move.nasty-plot": "Trama",
  "move.night-shade": "Sombra Noturna",
  "move.night-slash": "Talho Noturno",
  "move.no-retreat": "Sem Retirada",
  "move.nuzzle": "Chamego",
  "move.outrage": "Ultraje",
  "move.overheat": "Superaquecimento",
  "move.pain-split": "Divisão da Dor",
  "move.parabolic-charge": "Carga Parabólica",
  "move.pay-day": "Dia de Pagamento",
  "move.payback": "Revide",
  "move.peck": "Bicada",
  "move.perish-song": "Canção Perversa",
  "move.petal-dance": "Dança de Pétalas",
  "move.phantom-force": "Força Fantasma",
  "move.play-rough": "Jogo Duro",
  "move.pollen-puff": "Bola de Pólen",
  "move.poltergeist": "Poltergeist",
  "move.pound": "Pancada",
  "move.powder-snow": "Nevasca de Pó",
  "move.power-swap": "Troca de Poder",
  "move.power-up-punch": "Soco Poderoso",
  "move.power-whip": "Chicote Poderoso",
  "move.psybeam": "Feixe Psíquico",
  "move.psychic": "Psíquico",
  "move.psycho-cut": "Corte Psíquico",
  "move.psyshock": "Choque Psíquico",
  "move.psystrike": "Golpe Psíquico",
  "move.pursuit": "Perseguição",
  "move.pyro-ball": "Bola de Fogo",
  "move.quick-attack": "Ataque Rápido",
  "move.rapid-spin": "Giro Rápido",
  "move.razor-leaf": "Folha Navalha",
  "move.recover": "Recuperar",
  "move.rest": "Descanso",
  "move.rock-polish": "Polimento Rochoso",
  "move.rock-slide": "Deslize de Rochas",
  "move.rock-smash": "Esmagamento de Pedras",
  "move.rock-tomb": "Túmulo de Rochas",
  "move.rollout": "Rolar",
  "move.sacred-fire": "Fogo Sagrado",
  "move.sacred-sword": "Espada Sagrada",
  "move.safeguard": "Velo Místico",
  "move.sand-attack": "Ataque de Areia",
  "move.sand-tomb": "Sepultamento de Areia",
  "move.scald": "Escaldar",
  "move.scratch": "Arranhão",
  "move.seed-bomb": "Bomba de Sementes",
  "move.shadow-ball": "Bola Sombria",
  "move.shadow-claw": "Garra Sombria",
  "move.shadow-sneak": "Sombra Furtiva",
  "move.shell-smash": "Quebra-cascos",
  "move.sing": "Cantar",
  "move.skull-bash": "Cabecada",
  "move.sky-attack": "Ataque Celeste",
  "move.slack-off": "Omitir",
  "move.slash": "Talho",
  "move.sludge-bomb": "Bomba de Lodo",
  "move.smack-down": "Queda Livre",
  "move.smart-strike": "Golpe Certeiro",
  "move.smokescreen": "Tela de Fumaça",
  "move.snarl": "Rosnado",
  "move.snipe-shot": "Tiro de Elite",
  "move.soft-boiled": "Ovo Cozido",
  "move.solar-beam": "Raio Solar",
  "move.solar-blade": "Lâmina Solar",
  "move.spark": "Faísca",
  "move.spirit-shackle": "Cadeia Espiritual",
  "move.splash": "Splash",
  "move.stealth-rock": "Armadilha de Rochas",
  "move.stomp": "Pisotear",
  "move.stone-edge": "Pedra Afiada",
  "move.stored-power": "Poder Reserva",
  "move.stuff-cheeks": "Bochechas Cheias",
  "move.submission": "Submissão",
  "move.substitute": "Substituto",
  "move.sucker-punch": "Soco Surpresa",
  "move.supercell-slam": "Pancada Trovejante",
  "move.superpower": "Superpoder",
  "move.surf": "Surf",
  "move.surging-strikes": "Golpes Surpreendentes",
  "move.sweet-kiss": "Beijo Doce",
  "move.sweet-scent": "Aroma Doce",
  "move.swift": "Meteoros",
  "move.swords-dance": "Dança das Espadas",
  "move.synthesis": "Síntese",
  "move.tackle": "Investida",
  "move.tail-whip": "Chicote de Cauda",
  "move.tailwind": "Cauda Vento",
  "move.take-down": "Investida Destruidora",
  "move.tearful-look": "Olhar Lacrimejante",
  "move.telekinesis": "Telecinese",
  "move.teleport": "Teleporte",
  "move.thief": "Roubar",
  "move.throat-chop": "Golpe de Garganta",
  "move.thunder": "Trovão",
  "move.thunder-punch": "Soco Trovão",
  "move.thunder-shock": "Choque do Trovão",
  "move.thunder-wave": "Onda de Trovão",
  "move.thunderbolt": "Raio",
  "move.trailblaze": "Rastro Flamejante",
  "move.tri-attack": "Triataque",
  "move.trick": "Truque",
  "move.trick-room": "Espaço Estranho",
  "move.triple-axel": "Triplo Axel",
  "move.trop-kick": "Chute Tropical",
  "move.twister": "Twister",
  "move.vine-whip": "Chicote de Vinha",
  "move.volt-switch": "Troca Elétrica",
  "move.volt-tackle": "Investida Elétrica",
  "move.water-gun": "Pistola d'Água",
  "move.water-pulse": "Pulso d'Água",
  "move.water-shuriken": "Shuriken d'Água",
  "move.water-spout": "Jorrada",
  "move.waterfall": "Cachoeira",
  "move.whirlpool": "Redemoinho",
  "move.wicked-blow": "Golpe Obscuro",
  "move.wide-guard": "Barreira Ampla",
  "move.wild-charge": "Investida Selvagem",
  "move.will-o-wisp": "Fogo Fátuo",
  "move.wing-attack": "Ataque de Asa",
  "move.wish": "Desejo",
  "move.wood-hammer": "Martelo de Madeira",
  "move.x-scissor": "Tesoura-X",
  "move.yawn": "Bocejo",
  "move.zap-cannon": "Canhão Elétrico",
  "move.zen-headbutt": "Cabeçada Zen",
// @end move-names-i18n
  // Battle Items
  "battle-item.potion": "Poção",
  "battle-item.x-attack": "Ataque X",
  "battle-item.x-speed": "Velocidade X",
  "battle-item.fluffy-tail": "Cauda Felpuda",
  "battle-item.eject-button": "Botão de Ejeção",
  "battle-item.slow-smoke": "Fumaça Lenta",
  "battle-item.full-heal": "Cura Total",
  "battle-item.goal-getter": "Goleador",
  "battle-item.shedinja-doll": "Boneca Shedinja",
  "battle-item.goal-hacker": "Infiltrador de Gol",
  // Held Items
  "held-item.aeos-cookie": "Biscoito Aeos",
  "held-item.attack-weight": "Peso de Ataque",
  "held-item.special-attack-specs": "Esp. de Atq. Esp.",
  "held-item.shell-bell": "Sino Concha",
  "held-item.float-stone": "Pedra Flutuante",
  "held-item.muscle-band": "Faixa Muscular",
  "held-item.scope-lens": "Lente de Mira",
  "held-item.wise-glasses": "Óculos Sábios",
  "held-item.leftovers": "Sobras",
  "held-item.exp-share": "Compartilhar Exp.",
  "held-item.focus-band": "Faixa de Foco",
  "held-item.energy-amplifier": "Amplificador de Energia",
  "held-item.buddy-barrier": "Barreira do Companheiro",
  "held-item.score-shield": "Escudo de Pontos",
  "held-item.assault-vest": "Colete de Assalto",
  "held-item.rocky-helmet": "Capacete Rochoso",
  "held-item.razor-claw": "Garra Afiada",
  "held-item.choice-specs": "Óculos da Escolha",
  "held-item.weakness-policy": "Política de Fraqueza",
  "held-item.rapid-fire-scarf": "Cachecol de Tiro Rápido",
  "held-item.drain-crown": "Coroa Dreno",
  "held-item.slick-spoon": "Colher Lisa",
  "held-item.rescue-hood": "Capuz Resgate",
  "held-item.curse-bangle": "Pulseira Amaldiçoada",
  "held-item.curse-incense": "Incenso Amaldiçoado",
  "held-item.charging-charm": "Amuleto de Carregamento",
  "held-item.resonant-guard": "Guarda Ressonante",
  "held-item.drive-lens": "Lente Acionadora",
  "held-item.accel-bracer": "Bracelete Accel",
  "held-item.amulet-coin": "Moeda Amuleto",
  "held-item.choice-scarf": "Cachecol da Escolha",
  "held-item.big-root": "Raiz Grande",
  "held-item.tenacity-belt": "Cinto de Tenacidade",
  "held-item.vanguard-bell": "Sino Vanguarda",
  "held-item.rusted-sword": "Espada Enferrujada",
  "held-item.mewtwonite-x": "Mewtunita X",
  "held-item.mewtwonite-y": "Mewtunita Y",
  "held-item.lucarionite": "Lucariônita",
  "held-item.charizardite-x": "Charizardita X",
  "held-item.charizardite-y": "Charizardita Y",
  "held-item.gyaradosite": "Gyaradosita",
  // Maps — names and descriptions
  "map-groudon": "Ruínas Celestes de Theia",
  "map-groudon.description": "Mapa 5v5 com Groudon.",
  "map-kyogre": "Ruínas Celestes de Theia",
  "map-kyogre.description": "Mapa 5v5 com Kyogre.",
  "map-rayquaza": "Ruínas Celestes de Theia",
  "map-rayquaza.description": "Mapa 5v5 com Rayquaza.",
  // Spawn info (HTML) — principais textos; demais usam fallback en
  "spawn.info.groudon.boss":
    "<p>Ao ser derrotado, todos os membros vivos do time recebem <strong>buff</strong> e <strong>15 pontos aeos</strong>.<br>O buff é <strong>permanente até o portador ser nocauteado</strong>. Ao ser nocauteado, o buff <strong>transfere para quem aplicou o KO</strong>.<br>Concede <strong>aumento de velocidade de pontuação</strong>, <strong>grande aumento de dano</strong> e <strong>pequeno escudo</strong>.<br>Sempre aparece às 2:00.</p>",
  "spawn.info.kyogre.boss":
    "<p>Ao ser derrotado, todos os membros vivos do time recebem <strong>buff</strong>, <strong>15 pontos aeos</strong> e as torres adversárias ainda de pé ficam desativadas por 1:30 (adversário não recebe escudo e regeneração).<br>O buff é <strong>permanente até o portador ser nocauteado</strong>. Ao ser nocauteado, o buff <strong>transfere para quem aplicou o KO</strong>.<br>Concede <strong>aumento de velocidade de pontuação</strong>, <strong>autorregeneração (5% por segundo)</strong> e <strong>pequeno escudo</strong>.<br>Sempre aparece às 2:00.</p>",
  "spawn.info.rayquaza.boss":
    "<p>Ao ser derrotado, concede ao time vencedor <strong>15 pontos aeos</strong>, um <strong>escudo</strong> que <strong>acelera a pontuação</strong> e <strong>impede que gols sejam bloqueados</strong>.<br>Sempre aparece às 2:00.</p>",
  "spawn.info.bunnelby.initial":
    "<p><strong>Aparecem no início da partida</strong> e <strong>não ressurgem</strong> após derrotados.</p><p>Dão 2 pontos.</p>",
  "spawn.info.bunnelby.points":
    "<p>Dão 2 pontos.</p>",
  "spawn.info.regi.700":
    "<p>Aparece às <strong>7:00</strong>.</p>",
  "spawn.info.bunnelby.lane_940":
    "<p>Começa a aparecer às <strong>9:40</strong>.</p><p>Quando derrotado, concede <strong>2 pontos</strong> e ressurgem após <strong>60 segundos</strong>.</p><p>Se alguma das <strong>primeiras torres</strong> da lane for destruída, <strong>desaparece</strong>.</p>",
  "spawn.info.bunnelby.lane_920":
    "<p>Começa a aparecer às <strong>9:20</strong>.</p><p>Quando derrotado, concede <strong>2 pontos</strong> e ressurgem após <strong>60 segundos</strong>.</p><p>Se alguma das <strong>primeiras torres</strong> da lane for destruída, <strong>desaparece</strong>.</p>",
  "spawn.info.bunnelby.lane_915":
    "<p>Começa a aparecer às <strong>9:15</strong>.</p><p>Quando derrotado, concede <strong>2 pontos</strong> e ressurgem após <strong>60 segundos</strong>.</p><p>Se alguma das <strong>primeiras torres</strong> da lane for destruída, <strong>desaparece</strong>.</p>",
  "spawn.info.accelgor":
    "<p>Começa a aparecer às <strong>9:45</strong>.</p><p>Quando derrotado, concede <strong>4 / 7 pontos</strong> e um <strong>buff</strong>. <strong>Ressurge após 60 segundos</strong>.</p><p>O buff dura <strong>70 segundos</strong> e concede <strong>10% de redução no tempo de recarga dos movimentos</strong>.</p>",
  "spawn.info.escavalier":
    "<p>Começa a aparecer às <strong>9:45</strong>.</p><p>Quando derrotado, concede <strong>4 / 7 pontos</strong> e um <strong>buff</strong>. <strong>Ressurge após 60 segundos</strong>.</p><p>O buff dura <strong>70 segundos</strong> e concede <strong>dano extra em ataques básicos e reduz a velocidade de movimento do oponente por um curto tempo</strong>.</p>",
  "spawn.info.baltoy.generic":
    "<p>Começa a aparecer às <strong>9:45</strong>.</p><p>Quando derrotado, concede <strong>2 pontos</strong>. <strong>Ressurge após 60 segundos</strong>.</p>",
  "spawn.info.baltoy.lane_940":
    "<p>Começa a aparecer às <strong>9:40</strong>.</p><p>Quando derrotado, concede <strong>2 pontos</strong>. <strong>Ressurge após 60 segundos</strong>.</p><p>Se alguma das <strong>primeiras torres</strong> da lane for destruída, <strong>desaparece</strong>.</p>",
  "spawn.info.baltoy.lane_920":
    "<p>Começa a aparecer às <strong>9:40</strong>.</p><p>Quando derrotado, concede <strong>2 pontos</strong>. <strong>Ressurge após 60 segundos</strong>.</p><p>Se alguma das <strong>primeiras torres</strong> da lane for destruída, <strong>desaparece</strong>.</p>",
  "spawn.info.baltoy.lane_910":
    "<p>Começa a aparecer às <strong>9:10</strong>.</p><p>Quando derrotado, concede <strong>2 pontos</strong>. <strong>Ressurge após 60 segundos</strong>.</p><p>Se alguma das <strong>primeiras torres</strong> da lane for destruída, <strong>desaparece</strong>.</p>",
  "spawn.info.baltoy.lane_910_only":
    "<p>Começa a aparecer às <strong>9:10</strong>.</p><p>Quando derrotado, concede <strong>2 pontos</strong>. <strong>Ressurge após 60 segundos</strong>.</p>",
  "spawn.info.baltoy.lane_840":
    "<p>Começa a aparecer às <strong>8:40</strong>.</p><p>Quando derrotado, concede <strong>2 pontos</strong>. <strong>Ressurge após 60 segundos</strong>.</p>",
  "spawn.info.baltoy.tower":
    "<p>Começa a aparecer quando a <strong>primeira torre correspondente</strong> for destruída.</p><p>Quando derrotado, concede <strong>2 pontos</strong>. <strong>Ressurge após 60 segundos</strong>.</p>",
  "spawn.info.regidrago":
    "<p>Aparece no <strong>centro do mapa às 8:00</strong>. Quando derrotado, <strong>Altaria aparece 1:30 minuto depois</strong>.<br>O time que derrotar o <strong>Regidrago</strong> ganha <strong>experiência para todos os aliados</strong>.<br>Quem aplicar o golpe final recebe <strong>buff de velocidade de pontuação</strong> e <strong>20 pontos</strong>.</p>",
  "spawn.info.regieleki":
    "<p>Aparece às <strong>7:00</strong> em uma lane aleatória entre <strong>topo e base</strong>.<br>Quando derrotado, vai até a base do time adversário e, se tocar a base, pontua <strong>20/16/12/8 pontos</strong>; se a base ainda estiver de pé, <strong>gols ficam instantâneos por 20/15/10/5s</strong>.<br>Quem aplicar o golpe final recebe <strong>20 pontos</strong>.<br>Ressurge <strong>2 minutos</strong> após a morte.</p>",
  "spawn.info.xatu":
    "<p>Aparece às <strong>9:59</strong>.</p><p>Concede <strong>muita experiência</strong> e <strong>2 pontos</strong> quando derrotado.</p><p><strong>Não ressurgem</strong>.</p>",
  "spawn.info.natu.900":
    "<p>Aparece às <strong>9:00</strong>.</p>",
  "spawn.info.natu.920":
    "<p>Aparece às <strong>9:20</strong>.</p>",
  "spawn.info.indeedee.lane":
    "<p>Começa a aparecer às <strong>9:30</strong> / <strong>9:35</strong>.</p><p>Quando derrotado, <strong>ressurge após 60 segundos</strong> e concede <strong>5 pontos</strong>.</p><p>Se alguma das <strong>primeiras torres</strong> da lane for destruída, <strong>desaparece</strong>.</p>",
  "spawn.info.indeedee.tower":
    "<p>Aparece quando a <strong>primeira torre correspondente</strong> for destruída.</p><p>Quando derrotado, <strong>ressurge após 60 segundos</strong> e concede <strong>5 pontos</strong>.</p>",
  "spawn.info.salac":
    "<p>Quando consumido, concede <strong>bônus de velocidade de movimento</strong> por <strong>3 segundos</strong>.</p><p>Começa a aparecer às <strong>8:30</strong> e ressurgem <strong>60 segundos</strong> após o consumo.</p>",
  "spawn.info.salac.short":
    "<p>Bônus de velocidade de movimento por 3 segundos.</p>",
  "spawn.info.altaria.after_regidrago":
    "<p>Começa a aparecer <strong>1:30 após o Regidrago ser derrotado</strong>.</p>",
  "spawn.info.altaria.rayquaza":
    "<p>Aparece às <strong>8:00</strong> e resurge a cada <strong>1:30</strong>.</p><p>Desaparece às <strong>2:30</strong>.</p>",
  "spawn.info.regidrago.kyogre":
    "<p>Aparece no <strong>centro do mapa às 8:00</strong>.</p>",
  "spawn.info.xatu.short":
    "<p>Aparece às <strong>9:59</strong>.</p>",
  "spawn.info.indeedee.tower_break":
    "<p>Aparece quando torre é destruída.</p>",
  "spawn.info.baltoy.tower_break":
    "<p>Aparece quando torre é destruída.</p>",
  "spawn.info.bunnelby.lane":
    "<p>Começa a aparecer às <strong>9:40</strong>.</p>",
  "spawn.info.bunnelby.lane_920_short":
    "<p>Começa a aparecer às <strong>9:20</strong>.</p>",
  "spawn.info.bunnelby.lane_915_short":
    "<p>Começa a aparecer às <strong>9:15</strong>.</p>",
  "spawn.info.baltoy.lane_940_short":
    "<p>Começa a aparecer às <strong>9:40</strong>.</p>",
  "spawn.info.baltoy.945_short":
    "<p>Começa a aparecer às <strong>9:45</strong>.</p>",
  "spawn.info.baltoy.lane_910_short":
    "<p>Começa a aparecer às <strong>9:10</strong>.</p>",
  "spawn.info.baltoy.lane_840_short":
    "<p>Começa a aparecer às <strong>8:40</strong>.</p>",
  "spawn.info.indeedee.lane_930":
    "<p>Começa a aparecer às <strong>9:30</strong>.</p>",
  "spawn.info.indeedee.lane_935":
    "<p>Começa a aparecer às <strong>9:35</strong>.</p>",
  "spawn.info.baltoy.tower_kyogre":
    "<p>Começa a aparecer quando a <strong>primeira torre correspondente</strong> for destruída.</p>",
  "spawn.info.indeedee.tower_short":
    "<p>Aparece quando a <strong>primeira torre correspondente</strong> for destruída.</p>",
};

export default ptBR;
